export default {
    namespaced: true,
    state: {
      counter: 100
    },
    getters: {
      getPosition: state => {
        return state.counter <= 0 ? 1 : state.counter + 1;
      }
    },
    mutations: {
      inc: state => {
        state.counter++;
      },
      dec: state => {
        state.counter--;
      }
    },
    actions: {
      inc: ({ commit }) => {
        return new Promise(resolve => {
          commit("inc");
          resolve();
        });
      },
      dec: ({ commit }) => {
        return new Promise(resolve => {
          commit("dec");
          resolve();
        });
      }
    }
  };
  